import { z } from "zod";
import { format } from "date-fns";

const optional = () => z.string().optional().or(z.literal(""));

export const paymentFormSchema = z.object({
  client_id: z.string().min(1, "Client is required"),
  invoice_id: optional(),
  payment_date: z.string().min(1),
  amount: z.coerce.number().positive("Amount must be greater than 0"),
  payment_method: z.enum(["cash", "upi", "card", "bank_transfer", "cheque", "other"]),
  reference: optional(),
  notes: optional(),
});

export type PaymentFormValues = z.infer<typeof paymentFormSchema>;

export const emptyPaymentForm: PaymentFormValues = {
  client_id: "",
  invoice_id: "",
  payment_date: format(new Date(), "yyyy-MM-dd"),
  amount: 0,
  payment_method: "bank_transfer",
  reference: "",
  notes: "",
};
